import { uploadFile } from '../lib/api';

export const uploadImage = async (file, _bucket = 'images', subfolder = 'blogs') => {
  try {
    if (!file) {
      throw new Error('Dosya seçilmedi');
    }

    const MAX_FILE_SIZE = 5 * 1024 * 1024;
    if (file.size > MAX_FILE_SIZE) {
      throw new Error('Dosya boyutu 5MB\'dan büyük olamaz');
    }

    const allowedTypes = ['image/jpeg', 'image/png', 'image/webp'];
    if (!allowedTypes.includes(file.type)) {
      throw new Error('Sadece JPEG, PNG ve WEBP formatları desteklenir');
    }

    const result = await uploadFile(file, {
      folder: `images/${subfolder}`,
    });

    return result.url;
  } catch (error) {
    console.error('Error uploading image:', error);
    throw error;
  }
};
